import { v4 as uuidv4 } from 'uuid'
import { CobranzasAxios } from './config'

export const consultInfoPerson = async (t_doc, n_doc) => {
  const { data } = await CobranzasAxios.post('/contract/information', { t_doc, n_doc })

  return {
    _idext: uuidv4(),
    name: data.nombre_o_razon_social ?? data.nombre,
    ruc: n_doc,
    address: data.direccion ?? '',
    email: '',
    system: 'NAPCOBRANZAS'
  }
}
